import axios from 'axios';


const API_URL = `${process.env.REACT_APP_SERVICE_URL}queues`;

export const endOfDay = async () => {
    console.log("end day client service")
    return axios.post(`${API_URL}/endDay`);
};


export const GetRoomQueue = async (roomId) => {
    console.log(roomId)
    return axios.get(`${API_URL}/roomQueue/${roomId}`);
};


export const getFirstInQueueByRoom = async (roomId) => {
    return axios.get(`${API_URL}/firstInQueue/${roomId}`);
};

export const getSecondInQueueByRoom = async (roomId) => {
    return axios.get(`${API_URL}/secondInQueue/${roomId}`);
};
